export const RATE_LIMIT_EVENT_NAME = 'hand-hygiene-rate-limit';

export interface RateLimitEventDetail {
  status: 429;
  source?: string;
  retryAfter?: string | null;
  occurredAt: number;
}

type RateLimitListener = (detail: RateLimitEventDetail) => void;

export const notifyRateLimited = (
  detail: Partial<Omit<RateLimitEventDetail, 'status' | 'occurredAt'>> = {},
) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(
    new CustomEvent<RateLimitEventDetail>(RATE_LIMIT_EVENT_NAME, {
      detail: {
        status: 429,
        source: detail.source,
        retryAfter: detail.retryAfter ?? null,
        occurredAt: Date.now(),
      },
    }),
  );
};

export const subscribeRateLimit = (listener: RateLimitListener) => {
  if (typeof window === 'undefined') {
    return () => undefined;
  }

  const handleRateLimit = (event: Event) => {
    listener((event as CustomEvent<RateLimitEventDetail>).detail);
  };

  window.addEventListener(RATE_LIMIT_EVENT_NAME, handleRateLimit);
  return () => window.removeEventListener(RATE_LIMIT_EVENT_NAME, handleRateLimit);
};
